import { Policy } from 'models/policies';
import api from 'shared/api';

import { BaseQuestionnaireSchema, BaseQuoteSchema } from './models';

export const fetchPolicy = async (policyId: string) => {
  const { data } = await api.network.get<Policy>(`/me/policies/${policyId}`);

  return data;
};

export const fetchQuestionnaire = async (questionnaireId: string) => {
  const response = await api.network.get<Record<string, unknown>>(
    `/checkout/generic/checkouts/questionnaires/${questionnaireId}`
  );

  return BaseQuestionnaireSchema.parseAsync(response.data);
};

export const fetchQuote = async (quoteId: string) => {
  const response = await api.network.get<Record<string, unknown>>(
    `/checkout/generic/checkouts/quotes/${quoteId}`
  );

  return BaseQuoteSchema.parseAsync(response.data);
};
